import workplaceReducer from '@organisms/workers/workplaceList/common/redux/workplaceListSlice';
import { combineReducers } from '@reduxjs/toolkit';

const workersRootReducer = combineReducers({
    workplace: workplaceReducer,
});

export default workersRootReducer;
